import $ from 'jquery';

var $clearFiltersBtnBlogPage = $('.blog-button-clear-filters');
var $clearFiltersBtnEventPage = $('.event-button-clear-filters');
var $clearFiltersBtnNewsPage = $('.news-button-clear-filters');

// check if the clear filter button even exists on the page
if($clearFiltersBtnBlogPage.length) {
    // click event
    // when clicked, utilize the select2 method of clearing selections
    // https://select2.org/programmatic-control/add-select-clear-items
    $clearFiltersBtnBlogPage.on('click', function() {
        var $singleSelectDropdowns = $("#filterContainerBlog .blog-shea-custom-dropdown-singleselect");

        $singleSelectDropdowns.each(function (index, elem) {
            var dropdown = $(this);
            dropdown.val(null).trigger('change');   
        });

        var $checkboxes = $("#additionalFilterContainerBlog input");
        $checkboxes.each(function (index, elem) {
            var checkbox = $(this);
            checkbox.removeAttr("checked");
        });
    });
}

// check if the clear filter button even exists on the page
if($clearFiltersBtnEventPage.length) {
    // click event
    // when clicked, utilize the select2 method of clearing selections
    // https://select2.org/programmatic-control/add-select-clear-items
    $clearFiltersBtnEventPage.on('click', function() {
        var $singleSelectDropdowns = $("#filterContainerEvent .event-shea-custom-dropdown-singleselect");

        $singleSelectDropdowns.each(function (index, elem) {
            var dropdown = $(this);
            dropdown.val(null).trigger('change');   
        });

        var $checkboxes = $("#additionalFilterContainerEvent input");
        $checkboxes.each(function (index, elem) {
            var checkbox = $(this);
            checkbox.removeAttr("checked");
        });
    });
}

// check if the clear filter button even exists on the page
if($clearFiltersBtnNewsPage.length) {
    // click event
    // when clicked, utilize the select2 method of clearing selections
    // https://select2.org/programmatic-control/add-select-clear-items
    $clearFiltersBtnNewsPage.on('click', function() {
        var $singleSelectDropdowns = $("#filterContainerNews .news-shea-custom-dropdown-singleselect");

        $singleSelectDropdowns.each(function (index, elem) {
            var dropdown = $(this);
            dropdown.val(null).trigger('change');   
        });

        var $checkboxes = $("#additionalFilterContainerNews input");
        $checkboxes.each(function (index, elem) {
            var checkbox = $(this);
            checkbox.removeAttr("checked");
        });
    });
}

var $reqService = $('#form-msh-request-service');
if($reqService.length) {
// Form validation states
    $(document)

    // form validation passed
    // hide form container and show confirmation message container
    .on("formvalid.zf.abide", function(ev,frm) {
        // ! back-end: ajax post form
        var formId = frm.attr('id');
        window.showPreLoader();
        if (formId === 'form-msh-request-service') {
            // Call the submit function
            // Code in the submit is asynchronous, so need to pass a function to call after the submission is done
            window.abideFunctionMapper.call("msh", "forms", "requestServiceSubmit", function() { window.hidePreLoader(); });
        } else {
            window.hidePreLoader();
        }
    });

    // to prevent form from submitting upon successful validation
    $reqService.on("submit", function(ev) {
        ev.preventDefault();
    });
}

//Only disable submit on forms that post via ajax
$('.abide-form-ajax')
    // to prevent form from submitting upon successful validation
    .on("submit", function(ev) {
        ev.preventDefault();
});
